export const siteCategories = ["全部", "常用工具", "影视娱乐", "学习资源", "生活服务", "资讯阅读", "数码科技", "效率办公"];

export const siteList = [
  {
    title: "轻效率工具箱",
    summary: "在线处理类小工具合集，截图标注、图片压缩、格式转换无需安装，打开网页就能用完即走。",
    category: "常用工具",
    domain: "toolbox.qing.example.com",
    badge: "老牌",
  },
  {
    title: "慢读公开课",
    summary: "按学科整理的公开课目录，每门课标注难度等级与预计学时，适合想系统补基础的人按图索骥。",
    category: "学习资源",
    domain: "openclass.mandu.example.com",
    badge: "精选",
  },
  {
    title: "静音电台集",
    summary: "专注与放松两套常驻歌单，页面无弹窗无广告条，适合在工作学习时挂着当背景音使用。",
    category: "影视娱乐",
    domain: "radio.jingyin.example.com",
    badge: "干净",
  },
  {
    title: "随手记事本",
    summary: "打开即写的极简云笔记，支持标签归档与多端同步，用来记录临时灵感和待办清单刚刚好。",
    category: "效率办公",
    domain: "note.suishou.example.com",
    badge: "轻量",
  },
  {
    title: "本地生活通",
    summary: "把社保、公积金、水电缴费和出行查询聚到一页，办事前先看指南，少跑冤枉路。",
    category: "生活服务",
    domain: "life.bendi.example.com",
    badge: "实用",
  },
  {
    title: "极客快评",
    summary: "数码新品评测与拆解内容汇总，文末附真实参数对照表，选购下单前值得花十分钟刷一遍。",
    category: "数码科技",
    domain: "review.jike.example.com",
    badge: "干货",
  },
  {
    title: "今日要闻速览",
    summary: "把多家媒体的头条浓缩成短句列表，三分钟看完全天脉络，适合通勤路上快速补课。",
    category: "资讯阅读",
    domain: "news.jinri.example.com",
    badge: "及时",
  },
  {
    title: "比价小助手",
    summary: "输入商品名称即可横向对比多个平台的到手价与优惠券，购物前先比一比心里更有底。",
    category: "常用工具",
    domain: "price.bijia.example.com",
    badge: "省钱",
  },
  {
    title: "开源项目集市",
    summary: "按语言和用途分类的开源项目导航，每项附一句话简介与活跃度标记，找轮子不用翻论坛。",
    category: "数码科技",
    domain: "opensource.jishi.example.com",
    badge: "活跃",
  },
  {
    title: "通勤影单",
    summary: "按片长筛选的观影清单，通勤路上想看一集就走的短剧、纪录片都能按时间挑到。",
    category: "影视娱乐",
    domain: "movie.tongqin.example.com",
    badge: "按需",
  },
  {
    title: "文档速查手册",
    summary: "常用软件的快捷键与命令速查表合集，打印或收藏为书签都方便，急用时一搜就有。",
    category: "学习资源",
    domain: "docs.sucha.example.com",
    badge: "速查",
  },
  {
    title: "团队协作台",
    summary: "任务看板、共享日历与在线文档三件套导航入口，小团队开箱即用的协作起点。",
    category: "效率办公",
    domain: "team.xiezuo.example.com",
    badge: "团队",
  },
];